import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Menu,
  MenuItem,
  Select,
  Typography,
  useTheme
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TranslateIcon from "@material-ui/icons/Translate";
import Alert from "@material-ui/lab/Alert";
import clsx from "clsx";
import ColorButton from "components/common/ColorButton";
import FileType from "components/common/FileType";
import InfoIconButton from "components/common/InfoIconButton";
import ButtonController from "components/request-document/components/ButtonController";
import {
  StyleCheckbox,
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import useUploadDocumentForm from "components/request-document/hooks/useUploadDocumentForm";
import PersonalSignatureDialogButton from "components/user/PersonalSignatureDialogButton";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import useModalLoading from "libs/hooks/useModalLoading";
import { getFileObjectURL, getPathFile, openFileById } from "libs/utils/file";
import { countPrevTopic } from "libs/utils/uploadDocument";
import { get } from "lodash-es";
import mime from "mime";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { translateDoc } from "redux/modules/allDocumentsSlice";
import { canEditForm } from "redux/modules/authSlice";
import { selectCurrentDocument } from "redux/modules/visaForm";
import FileService from "services/FileService";
import ReportService from "services/ReportService";
import VisaFormService from "services/VisaFormService";

function UploadButton({ id, onChange, title, disabled }) {
  return (
    <div>
      <input
        disabled={disabled}
        style={{ display: "none" }}
        id={`contained-button-file-${id}`}
        type="file"
        onChange={onChange}
      />
      <label htmlFor={`contained-button-file-${id}`}>
        <ColorButton
          disabled={disabled}
          component="span"
          fullWidth={false}
          style={{ width: 82, backgroundColor: "#00D0FF", fontWeight: "bold" }}
          variant="contained"
          color="info"
          size="small"
        >
          + ADD
        </ColorButton>
      </label>
    </div>
  );
}

const InfoButton = ({ id, onRemoveAll, disabled }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <InfoIconButton
        disabled={disabled}
        aria-controls={`info-menu-${id}`}
        aria-haspopup="true"
        onClick={handleClick}
      />
      <Menu
        id={`info-menu-${id}`}
        anchorEl={anchorEl}
        keepMounted={false}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        elevation={1}
      >
        <MenuItem
          onClick={async () => {
            handleClose();
            await onRemoveAll();
          }}
        >
          Remove all files
        </MenuItem>
      </Menu>
    </>
  );
};

export default function UploadDucument({
  isExtension,
  isChange,
  onUploaded = () => { },
  setSaveDraft = () => { },
}) {
  const theme = useTheme();
  const classes = useStyles();
  const { showLoading, hideLoading } = useModalLoading();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);
  const [open, setOpen] = React.useState(false);
  const [smartIdSelected, setsmartIdSelected] = React.useState(null);
  const {
    personalID,
    documents,
    formik,
    condition,
    draftId,
    isDisabledRemoveButton,
    isDepartmentRequestDoc,
    reqdoclogList,
    onSaveDraft,
  } = useUploadDocumentForm({
    isExtension,
    isChange,
    canEdit,
    setSaveDraft,
  });

  const currentDocument = useSelector(selectCurrentDocument);
  const onClickViewDocument = async () => {
    const fileFullName = `${draftId}.pdf`;
    const blob = await ReportService.getResultSmartfromDetail({
      draftId: draftId,
    });

    const blobFile = new File([blob], fileFullName, {
      type: mime.getType(".pdf"),
    });

    window.open(URL.createObjectURL(blobFile), "_blank");
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
        <Typography style={{ marginBottom: 8 }}>
          Further guidance on the required documents is available on &nbsp;
          <a
            className={classes.link}
            href="http://smart-visa.boi.go.th"
            target="_blank"
            rel="noreferrer"
          >
            http://smart-visa.boi.go.th
          </a>
        </Typography>

        {Object.keys(formik.errors)
          .filter((key) => formik.touched[key])
          .map((key) => (
            <Alert key={key} severity="error">
              {formik.errors[key]}
            </Alert>
          ))}

        {documents.map((doc, docIndex) => (
          <Table className={classes.table} key={doc.seqTypedoc}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    {doc.title}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell align="center" width={180} colSpan={2}>
                  {docIndex === 0 ? "File Upload ( PDF, JPG )" : ""}
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {doc.topic.map((row, index) => (
                <React.Fragment key={row.seqDoc}>
                  <TableRow
                    style={{
                      backgroundColor:
                        index % 2 !== 0
                          ? theme.palette.background.main
                          : theme.palette.common.white,

                      ...(row.remark
                        ? {
                          backgroundColor: "rgb(253, 237, 237)",
                          borderRight: "1px solid red",
                          borderWidth: "2px 3px 2px 2px",
                          borderStyle: "solid",
                          borderColor: "red",
                        }
                        : {}),
                    }}
                  >
                    <StyledTableCell colSpan={2}>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <div style={{ display: "flex" }}>
                          <div className={classes.wrapTitleContent}>
                            <div className={classes.badge}>
                              {countPrevTopic(docIndex, documents) + index + 1}
                            </div>
                          </div>
                          <div style={{ display: "flex", flex: 1 }}>
                            <Typography>{row.title}</Typography>
                          </div>
                        </div>
                        <div
                          style={{ display: "flex", flex: 1, paddingLeft: 50 }}
                        >
                          <Typography color="error">{`${row.remark ? `* ${row.remark}` : ""
                            }`}</Typography>
                        </div>
                      </div>
                    </StyledTableCell>
                    <StyledTableCell align="center" style={{ width: 100 }}>
                      <UploadButton
                        disabled={!canEdit}
                        id={row.documentID}
                        onClick={() => {
                          if (!canEdit) {
                            return;
                          }
                        }}
                        onChange={async (event) => {
                          try {
                            if (!canEdit) {
                              return;
                            }
                            showLoading();

                            const response = await FileService.uploadFile({
                              file: event.target.files[0],
                              FileID: null,
                              Status: true,
                            });
                            // const responseOCR = await OCRService.read(
                            //   event.target.files[0]
                            // );

                            const fileId = response.results?.fileID;
                            const path = response.results?.path;
                            // const ocRtext = responseOCR?.results || "";
                            const ocRtext = "";

                            const fileObj = await getFileObjectURL(
                              getPathFile(path)
                            );
                            const currentDocTypeFiles =
                              formik.values[row.documentID] || [];

                            const [filename, ext] =
                              event.target.files[0].name.split(".");

                            formik.setFieldValue(row.documentID, [
                              ...currentDocTypeFiles,
                              {
                                file: fileObj,
                                filename,
                                ext,
                                // fileID: fileId,
                                personalID: personalID,
                                typedocId: row.typedocID,
                                documentID: row.documentID,
                                fileID: fileId,
                                status: true,
                                configDocumentRequiredID:
                                  row.configDocumentRequiredID,
                                smartId: row.smartId,
                                ocRtext: ocRtext,
                              },
                            ]);

                            if (isDepartmentRequestDoc) {
                              const detail = reqdoclogList.reduce((p, c) => {
                                const list = c.detail.filter(
                                  (v) =>
                                    v.configDocumentRequiredID ===
                                    row.configDocumentRequiredID
                                );
                                if (list.length) {
                                  return [
                                    ...p,
                                    ...list.map((m) => ({
                                      reqDocId: c.reqDocId,
                                      reqDetDocId: m.reqDetDocId,
                                      configDocumentRequiredID:
                                        m.configDocumentRequiredID,
                                      fileID: fileId,
                                    })),
                                  ];
                                }

                                return p;
                              }, []);
                              await VisaFormService.reqdoclogAdd({
                                draftId,
                                detail,
                              });
                              await onUploaded();
                            }

                            hideLoading();
                          } catch (error) {
                            hideLoading();
                          }
                        }}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center" style={{ width: 50 }}>
                      <InfoButton
                        disabled={!canEdit || isDisabledRemoveButton}
                        id={row.documentID}
                        onRemoveAll={async () => {
                          try {
                            showLoading();

                            const fileIds = get(
                              formik.values,
                              row.documentID,
                              []
                            ).map((file) => file.fileID);

                            const response = await Promise.all(
                              fileIds.map((fileId) =>
                                FileService.uploadFile({
                                  file: null,
                                  FileID: fileId,
                                  Status: false,
                                })
                              )
                            );

                            const currentDocFiles = formik.values[
                              row.documentID
                            ].map((value) => ({
                              ...value,
                              status: false,
                            }));

                            formik.setFieldValue(
                              row.documentID,
                              currentDocFiles
                            );

                            hideLoading();
                          } catch (error) {
                            hideLoading();
                          }
                        }}
                      />
                    </StyledTableCell>
                  </TableRow>
                  {get(formik.values, row.documentID, [])
                    .filter((tp) => tp.status)
                    .map((file) => (
                      <TableRow
                        key={file.fileId}
                        style={{
                          backgroundColor:
                            index % 2 !== 0
                              ? theme.palette.background.main
                              : theme.palette.common.white,
                        }}
                      >
                        <StyledTableCell
                          align="center"
                          style={{ borderRight: 0 }}
                        >
                          <div style={{ display: "flex", marginLeft: 58 }}>
                            <FileType title="Document file" file={file.file} />
                          </div>
                          {!canEdit && (
                            <div
                              style={{
                                marginLeft: 58,
                                marginTop: 10,
                                textAlign: "left",
                              }}
                            >
                              {file?.empId && (
                                <div
                                  style={{
                                    textAlign: "left",
                                    color: "#ed1c24",
                                    fontSize: "14px",
                                  }}
                                >
                                  Request from: ({file?.departmentName}){" "}
                                  {file?.empFirstName} {file?.empLastName}
                                </div>
                              )}

                              {file?.remark && (
                                <div
                                  style={{
                                    textAlign: "left",
                                    color: "lightslategray",
                                    fontSize: "14px",
                                  }}
                                >
                                  {file?.remark}
                                </div>
                              )}
                            </div>
                          )}

                          {canEdit && (
                            <div
                              style={{
                                marginLeft: 58,
                                marginTop: 10,
                                textAlign: "left",
                              }}
                            >
                              {file?.empId && (
                                <div
                                  style={{
                                    textAlign: "left",
                                    color: "#ed1c24",
                                    fontSize: "14px",
                                  }}
                                >
                                  Request from:{" "}
                                  {currentDocument?.smartform?.staffName}
                                </div>
                              )}

                              {file?.remark && (
                                <div
                                  style={{
                                    textAlign: "left",
                                    color: "lightslategray",
                                    fontSize: "14px",
                                  }}
                                >
                                  {file?.remark}
                                </div>
                              )}
                            </div>
                          )}
                        </StyledTableCell>

                        <StyledTableCell
                          align="center"
                          style={{ borderLeft: 0 }}
                        >
                          <ColorButton
                            disabled={!canEdit || isDisabledRemoveButton}
                            fullWidth={false}
                            style={{ width: 82, fontWeight: "bold" }}
                            variant="contained"
                            color="error"
                            size="small"
                            onClick={async (event) => {
                              try {
                                showLoading();

                                const fileId = file.fileID;
                                const response = await FileService.uploadFile({
                                  file: null,
                                  fileID: fileId,
                                  Status: false,
                                });

                                const currentDocTypeFiles = formik.values[
                                  row.documentID
                                ].map((value) => {
                                  if (value.fileID !== fileId) return value;
                                  return {
                                    ...value,
                                    status: false,
                                  };
                                });

                                formik.setFieldValue(
                                  row.documentID,
                                  currentDocTypeFiles
                                );

                                hideLoading();
                              } catch (error) {
                                hideLoading();
                              }
                            }}
                          >
                            Remove
                          </ColorButton>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <ColorButton
                            fullWidth={false}
                            style={{ width: 82, fontWeight: "bold" }}
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={async () => {
                              openFileById(file.fileID);
                            }}
                          >
                            View
                          </ColorButton>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {!canEdit && (
                            <>
                              <TranslateIcon
                                className={classes.translateIco}
                                onClick={() => {
                                  setsmartIdSelected(file.smartId);
                                  setOpen(true);
                                }}
                              />
                            </>
                          )}
                        </StyledTableCell>
                      </TableRow>
                    ))}
                </React.Fragment>
              ))}
            </TableBody>
          </Table>
        ))}

        {condition?.length > 0 && (
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={2}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Other Documents
                  </Typography>
                </StyledTableCell>
                <StyledTableCell
                  align="center"
                  width={180}
                  colSpan={2}
                ></StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {condition
                .map((file) => {
                  return {
                    ...file,
                    file: new File(
                      [new Blob()],
                      `${file.filename}${file.ext}`,
                      {
                        type: mime.getType(file.ext),
                      }
                    ),
                  };
                })
                .map((file, index) => (
                  <TableRow
                    key={file.fileId}
                    style={{
                      backgroundColor:
                        index % 2 !== 0
                          ? theme.palette.background.main
                          : theme.palette.common.white,
                    }}
                  >
                    <StyledTableCell colSpan={2}>
                      <div style={{ display: "flex", marginLeft: 58 }}>
                        <FileType title="Document file" file={file.file} />
                      </div>
                    </StyledTableCell>
                    <StyledTableCell align="center" style={{ width: 104 }}>
                      <ColorButton
                        // disabled={!canEdit}
                        fullWidth={false}
                        style={{ width: 82, fontWeight: "bold" }}
                        variant="contained"
                        color="secondary"
                        size="small"
                        onClick={async () => {
                          openFileById(file.fileID);
                        }}
                      >
                        View
                      </ColorButton>
                    </StyledTableCell>{" "}
                    <StyledTableCell align="center" style={{ width: 50 }}>
                      {!canEdit && (
                        <>
                          <TranslateIcon
                            className={classes.translateIco}
                            onClick={() => {
                              setsmartIdSelected(file.smartId);
                              setOpen(true);
                            }}
                          />
                        </>
                      )}
                    </StyledTableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          color: "#5f5f5f",
          marginTop: 16,
          marginLeft: 31,
        }}
      >
        <Typography variant="subtitle1">
          * Multiple files can be uploaded
        </Typography>
      </div>

      {canEdit && (
        <>
          <div
            style={{
              marginTop: 44,
              display: "flex",
              flexDirection: "column",
              padding: "0px 31px",
            }}
          >
            <div className={classes.cellContent}>
              <div className={classes.wrapField}>
                <FormGroup row>
                  <FormControlLabel
                    control={
                      <StyleCheckbox
                        name="accep1"
                        value={formik.values.accep1}
                        checked={Boolean(formik.values.accep1)}
                        onClick={() => {
                          formik.setFieldValue("accep1", !formik.values.accep1);
                        }}
                        style={{
                          marginTop: -13,
                        }}
                      />
                    }
                    style={{ marginBottom: 1 }}
                    label="I confirm that I have read the guidance and there are no other documents to submit. For documents that are not in English, I have provided a certified translation."
                  />
                </FormGroup>
              </div>
            </div>
            {!isDepartmentRequestDoc && (
              <div className={classes.cellContent}>
                <div className={classes.wrapField}>
                  <Typography
                    component="label"
                    style={{ cursor: "pointer", marginLeft: 30 }}
                    onClick={() => {
                      formik.setFieldValue("accep1", !formik.values.accep1);
                    }}
                  >
                    I hereby authorize One Stop Service Center for Visa and Work
                    Permit and related govenmental institutions to share this
                    information provided among the agencies involved in this
                    qualification endorsement process.
                  </Typography>
                  <Typography
                    component="label"
                    style={{ cursor: "pointer", marginLeft: 30, marginTop: 8 }}
                    onClick={() => {
                      formik.setFieldValue("accep1", !formik.values.accep1);
                    }}
                  >
                    I understand that a decision may be made on my application
                    based on these documents only.
                  </Typography>
                  <Typography
                    component="label"
                    style={{ cursor: "pointer", marginLeft: 30, marginTop: 8 }}
                    onClick={() => {
                      formik.setFieldValue("accep1", !formik.values.accep1);
                    }}
                  >
                    I understand that I may be contacted or requested for
                    additional documents or information from government offices
                    or its representative.
                  </Typography>
                </div>
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              padding: "21px 50px",
              color: "#5f5f5f",
              fontWeight: "bold",
            }}
          >
            <p>
              * All processes may take approximately 30 working days to process
              providing that you are able to provide all complete documents at
              the start, so please allow considerable time to begin the process
              before your immigration stamp expires.
            </p>
          </div>
        </>
      )}
      {canEdit && <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          padding: "21px 50px",
          marginTop: 16,
        }}
      >
        <PersonalSignatureDialogButton />
      </div>}
      <div style={{ display: "flex", justifyContent: "center", marginTop: 16 }}>
        <ColorButton
          variant="outlined"
          color="secondary"
          style={{
            width: 200,
            height: 50,
            borderWidth: 2,
            fontWeight: "bold",
            marginTop: 16,
          }}
          onClick={onClickViewDocument}
        >
          {/* <PrintIcon style={{ marginRight: 8 }} /> */}
          Summarize
        </ColorButton>
      </div>

      <ButtonController
        isDisabledNextButton={canEdit && !formik.values.accep1}
        onClickSaveDraft={onSaveDraft}
        hideSubmit={isDepartmentRequestDoc}
        hideSaveDraft={isDepartmentRequestDoc}
      />

      <TranslateResult
        open={open}
        smartId={smartIdSelected}
        onClose={async (docs) => {
          setOpen(false);
        }}
      />
    </form>
  );
}

const useStylesTranslateResult = makeStyles((theme) => ({
  warpDialog: {
    padding: "30px",
    minWidth: "600px",
    minHeight: "200px",
  },
  dtitle: {
    color: "#40B8D4",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  rowMenuPopOver: {
    display: "flex",
    flexDirection: "column",
    minHeight: 450,
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    borderTop: "0",
    boxShadow: "0 1px 4px 0 rgb(0 0 0 / 37%)",
  },
  wrapContent: {
    borderBottom: "1px solid rgba(0,0,0,0.12)",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    padding: 15,
  },
  btnTranslate: {
    background: "none",
    textTransform: "uppercase",
    fontFamily: '"Roboto", arial,sans-serif',
    fontSize: "14px",
    fontWeight: "500",
    paddingRight: "24px",
    paddingLeft: "24px",
    minWidth: "90px",
    display: "flex",
    justifyContent: "center",
    boxSizing: "border-box",
    margin: "0",
    paddingTop: "0",
    paddingBottom: "0",
    border: "none",
    outline: "none",
    textAlign: "center",
    whiteSpace: "nowrap",
    cursor: "pointer",
    WebkitAppearance: "none",
    zIndex: "1",
  },

  wrapBtnTranslate: {
    justifyContent: "flex-start",
    display: "flex",
  },
  btnActive: {
    color: "#1a73e8",
  },
  wrapText: {
    padding: "20px",
    fontSize: "16px",
    lineHeight: "28px",
  },
}));

function TranslateResult(props) {
  const classes = useStylesTranslateResult();
  const { onClose, open, smartId } = props;
  const dispatch = useDispatch();

  const { translateData } = useSelector((state) => state.allDocuments);
  const [translateCode, setTranslateCode] = React.useState("en");
  const [countryCode, setCountryCode] = React.useState(1);
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();

  useEffect(async () => { }, [open]);

  const counties = [
    {
      name: "The united states of America",
      code: "eng",
      id: 1,
    },
    {
      name: "France",
      code: "fra",
      id: 2,
    },
    {
      name: "Australia",
      code: "",
      id: 3,
    },
    {
      name: "Russia",
      code: "rus",
      id: 4,
    },
    {
      name: "Belgium",
      code: "bel",
      id: 5,
    },

    {
      name: "Germany",
      code: "deu",
      id: 6,
    },
    {
      name: "The United Kingdom",
      code: "eng",
      id: 7,
    },
    {
      name: "Japan",
      code: "jpn",
      id: 8,
    },
    {
      name: "India",
      code: "ind",
      id: 9,
    },

    {
      name: "The Netherlands",
      code: "nld",
      id: 10,
    },
    {
      name: "India",
      code: "ind",
      id: 11,
    },
    {
      name: "Canada",
      code: "",
      id: 12,
    },
    {
      name: "China",
      code: "chi_sim",
      id: 13,
    },
    {
      name: "Poland",
      code: "pol",
      id: 14,
    },
    {
      name: "Sweden",
      code: "swe",
      id: 15,
    },
    {
      name: "Italy",
      code: "ita",
      id: 16,
    },
    {
      name: "Switzerland",
      code: "",
      id: 17,
    },
    {
      name: "Taiwan",
      code: "",
      id: 18,
    },
    {
      name: "China (Hong Kong)",
      code: "",
      id: 19,
    },
    {
      name: "Denmark",
      code: "",
      id: 20,
    },
    {
      name: "Austria",
      code: "",
      id: 21,
    },
  ];

  const handleTranslate = async () => {
    showAdminLoading();
    const _countryCode = counties.find((x) => x.id === countryCode)?.code;
    const body = {
      smartId: smartId,
      languageCode: _countryCode,
      translateCode: translateCode,
    };
    await dispatch(translateDoc(body));
    hideAdminLoading();
  };
  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth
      maxWidth="xl"
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title">
        <div className={classes.dtitle}>
          <div>Document Translation</div>
          <div>
            <Button
              variant="outlined"
              size="medium"
              color="info"
              className={classes.buttonSave}
              onClick={handleClose}
            >
              ปิด
            </Button>
          </div>
        </div>
      </DialogTitle>
      <DialogContent style={{ paddingBottom: 23 }}>
        <div className={classes.rowMenuPopOver}>
          <Grid container className={classes.wrapContent}>
            <Grid item xs={12} sm={6}>
              <div>
                <Select
                  name={`countryCode`}
                  value={countryCode}
                  onChange={(e) => {
                    setCountryCode(e.target.value);
                  }}
                >
                  {counties.map((county, index) => (
                    <MenuItem
                      value={county.id}
                      key={county.id}
                      disabled={!county.code}
                    >
                      {county.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </Grid>
            <Grid item xs={12} sm={6}>
              <div
                className={classes.wrapBtnTranslate}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                >
                  <button
                    className={clsx(classes.btnTranslate, {
                      [classes.btnActive]: translateCode === "en",
                    })}
                    onClick={() => {
                      setTranslateCode("en");
                    }}
                  >
                    English
                  </button>
                  <button
                    onClick={() => {
                      setTranslateCode("th");
                    }}
                    className={clsx(classes.btnTranslate, {
                      [classes.btnActive]: translateCode === "th",
                    })}
                  >
                    Thai
                  </button>
                </div>

                <Button
                  variant="outlined"
                  size="small"
                  color="info"
                  className={classes.buttonSave}
                  style={{ backgroundColor: "#1a73e8", color: "white" }}
                  onClick={handleTranslate}
                >
                  Translate
                </Button>
              </div>
            </Grid>
          </Grid>
          <Grid container style={{ flex: 1 }}>
            <Grid item xs={12} sm={6}>
              <div className={classes.wrapText}>{translateData?.ocrText}</div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              style={{ borderLeft: "1px solid rgba(0,0,0,0.12)" }}
            >
              <div className={classes.wrapText}>
                {translateData?.translatedText}
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
    </Dialog>
  );
}
